import { useSetDisplayPreference } from "@/hooks/usePubmed";
import { pubmedState } from "@/stores/pubmed";
import { IconButton } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import React from "react";
import { useRecoilValue } from "recoil";

const key = "Helper";

const HelperButton: React.FC = () => {
  const {
    displayPreference: { verbose, defaultActiveKey },
  } = useRecoilValue(pubmedState);
  const { updatePreference, loading } = useSetDisplayPreference();

  return (
    <IconButton
      color="primary"
      onClick={() =>
        updatePreference(
          {
            verbose: verbose && defaultActiveKey !== key ? true : !verbose,
            defaultActiveKey: key,
          },
          true
        )
      }
      disabled={loading}
    >
      <EditIcon />
    </IconButton>
  );
};

export default HelperButton;
